<template>
  <div class="component-edit-box" :style="position">
    <div class="box-wrap" @click="editTopic"  v-if="answerSheet.acCardDJType != 1">
      <i class="el-icon-edit-outline" style="font-size: 18px; color: #fff"></i>
    </div>
    <div class="box-wrap" @click="deleteTopic" style="margin: 0 12px;"  v-if="answerSheet.acCardDJType != 1">
      <i class="el-icon-delete" style="font-size: 18px; color: #fff"></i>
    </div>
    <div class="box-wrap" style="background: none"
      v-if="isDis"
    >
    <el-popover
      placement="bottom"
      width="170"
      trigger="click"
      @show="showDialog"
      v-model="popoverVisible"
    >
      <div class="popover-cont">
        <template v-if="msg.types === 1">
          <p>
            <span class="popo-text">每组题数</span>
            <el-input-number
              v-model="objectiveForm.rowNum"
              controls-position="right"
              @change="handleRowsChange"
              :min="1"
              :max="10"
              size="mini"
              style="width: 100px"
            ></el-input-number>
          </p>
          <p>
            <span class="popo-text">排列方向</span>
            <el-select
              v-model="objectiveForm.diffLayout"
              placeholder="请选择"
              size="mini"
              style="width: 100px"
              @change="handleLayoutChange"
            >
              <el-option label="横排" :value="false"></el-option>
              <el-option label="竖排" :value="true"></el-option>
            </el-select>
          </p>
        </template>
        <template v-if="msg.types == 2">
          <p class="line">
            <span class="popo-text">作答长度</span>
            <el-select
              v-model="fillForm.rowNum"
              placeholder="请选择"
              size="mini"
              style="width: 100px"
              @change="fillRowNum(true)"
            >
              <el-option label="1/4" :value="0.4"></el-option>
              <el-option label="1/3" :value="0.3"></el-option>
              <el-option label="1/2" :value="0.2"></el-option>
              <el-option label="1" :value="1"></el-option>
              <el-option label="2" :value="2"></el-option>
            </el-select>
          </p>
          <div style="max-height: 130px; overflow-y: auto; padding-top: 15px">
            <p v-for="(fill, i) in fillForm.list" :key="'fill' + i">
              <span class="popo-text">{{ fill.tihao }}</span>
              <el-select
                v-model="fill.rowNum"
                placeholder="请选择"
                size="mini"
                style="width: 100px"
                @change="fillRowNum(false)"
              >
                <el-option label="1/4" :value="0.4"></el-option>
                <el-option label="1/3" :value="0.3"></el-option>
                <el-option label="1/2" :value="0.2"></el-option>
                <el-option label="1" :value="1"></el-option>
                <el-option label="2" :value="2"></el-option>
              </el-select>
            </p>
          </div>
        </template>
        <template v-if="msg.types == 3 || msg.types == 4 || msg.types == 6">
          <p>
            <span class="popo-text">样式</span>
            <el-select
              v-model="form346.sty"
              placeholder="请选择"
              size="mini"
              style="width: 100px"
              @change="fillRowNum(true)"
            >
              <el-option label="单行线" :value="1"></el-option>
              <el-option label="四线三格" :value="2"></el-option>
            </el-select>
          </p>
        </template>
        <template v-if="msg.types == 5">
          <p>
            <span class="popo-text">字数</span>
            <el-input-number
              v-model="writingForm.rowNum"
              controls-position="right"
              :min="1000"
              :max="2000"
              size="mini"
              style="width: 100px"
            ></el-input-number>
          </p>
          <p>
            <span class="popo-text">字数提示</span>
            <el-select
              v-model="writingForm.isNumPos"
              placeholder="请选择"
              size="mini"
              style="width: 100px"
              @change="fillRowNum(true)"
            >
              <el-option label="显示" :value="1"></el-option>
              <el-option label="不显示" :value="0"></el-option>
            </el-select>
          </p>
        </template>

        <p style="text-align: right">
          <el-button type="text" size="mini" @click="closePopover"
            >取消</el-button
          >
          <el-button type="primary" size="mini" @click="submitPopover"
            >确定</el-button
          >
        </p>
      </div>
      <el-button
        v-if="isDis"
        slot="reference"
        type="primary"
        icon="el-icon-s-operation"
        circle
        size="small"
        @click="showPopover"
      ></el-button>
    </el-popover>
    </div>
  </div>
</template>

<script>
import { mapState, mapGetters, mapMutations, mapActions } from "vuex";
import subjects from "@/store/modules/subjects";
import cardOperate from "@/assets/js/utils/cardOperate";
import { ObjectiveModel } from "@/subjects/objective/Objective.model";
import { WriteEnModel } from "@/subjects/writeEn/WriteEn.model";
import { setObjectiveHeight } from "@/utils/common";
export default {
  props: {
    position: String,
    msg: Object,
    isDis: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState("card", {
      subjects: (state) => state.subjects,
      pageCell: (state) => state.pageCell,
    }),
    ...mapState("answerPanel", {
      answerSheet: (state) => state.answerSheet,
    }),
  },
  data() {
    return {
      myindex: 0,
      visibleMap: {
        //  1 表示填空题，2 表示客观题，3 表示解答题，4表示英文作文，5表示语文作文，6表示选做题
        1: "fillBlankVisible2",
        2: "objectiveVisible",
        3: "answerVisible",
        4: "writeEnVisible",
        5: "writeVisible",
        6: "chooseVisible",
      },
      popoverVisible: false,
      objectiveForm: {
        rowNum: 5,
        diffLayout: false,
      },
      fillForm: {
        rowNum: null,
        list: [],
      },
      form346: {
        rowNum: 8,
        sty: 1,
      },
      writingForm: {
        rowNum: 1000,
        isNumPos: 1,
      },
      isFillChange: false,
    };
  },
  methods: {
    ...mapActions({
      setVisibleDialog: "answerPanel/setVisibleDialog",
      setVisibleDialogIndex: "answerPanel/setVisibleDialogIndex",
    }),
    ...mapMutations({
      deleteSubject: "card/deleteSubject",
      updateSubjects: "card/updateSubjects",
      resetPageCell: "card/resetPageCell",
    }), //参数的变动
    handleLayoutChange(a) {
      this.submitPopover()
    },
    
    handleRowsChange(val) {
      // this.submitPopover(false)
    },
    editTopic() {
      this.worEdit();
    },
    showDialog() {
      this.objectiveForm = {
        rowNum: this.msg.rowNum || 5,
        diffLayout: this.msg.diffLayout || false,
      };
    },
    setMyindex() {
      console.log("myindex", this.subjects, this.msg);
      this.subjects.forEach((subject, i) => {
        if (this.msg.th == subject.th) {
          this.myindex = i;
        }
      });
      return this.myindex;
    },
    async deleteTopic() {
      this.setMyindex();
      if (this.msg.type == 3) {
        // 解答题删除小题不全部删除处理
        this.deleteAnswerTopic();
      } else {
        await this.deleteSubject(this.myindex); // 通过下标删除指定元素
      }
      this.resetPageCell({
        acCardPanes: this.answerSheet.acCardPanes,
        index: this.myindex,
        deleteTH: this.msg.th,
      });
    },
    async deleteAnswerTopic() {
      console.log(this.msg);
      // 单独删除解答题小题
      let sameTopicList = []; // 把整个页面的pagecell的filltopiclist中属于该题号的题型stack存起来
      this.pageCell.forEach((page) => {
        page.fillTopiclist.forEach((topic) => {
          if (topic.th == this.msg.th) {
            sameTopicList.push(topic);
          }
        });
      });
      let result = [];
      const map = {}; //用来存储合并之后的数据
      sameTopicList.forEach((sameTopic, sameTopicIndex) => {
        if(!map[sameTopic.no + '-' + sameTopic.xth]){
          result.push(sameTopic);
          map[sameTopic.no + '-' + sameTopic.xth] = sameTopic;
        } else{
          for(var j = 0; j < result.length; j++){
            var nextsameTopic = result[j];
            if(nextsameTopic.xth && (nextsameTopic.no == sameTopic.no) && (nextsameTopic.xth == sameTopic.xth)){
              nextsameTopic.initDragHeight += sameTopic.initDragHeight -10;
              nextsameTopic.innerHTML += sameTopic.innerHTML;
              break;
            } else if (!nextsameTopic.xth &&(nextsameTopic.no == sameTopic.no)) {
              nextsameTopic.initDragHeight += sameTopic.initDragHeight -10;
              nextsameTopic.innerHTML += sameTopic.innerHTML;
              break;
            }
          }
        }
      })
      let [delTopic] = this.subjects.filter((topic) => {
        return this.msg.th == topic.th;
      });
      const { no,xth } = this.msg;  
      if (delTopic.htmlArray.length <= 1) {
        return await this.deleteSubject(this.myindex); // 通过下标删除指定元素
      }
      // let delIdsMap = [];
      delTopic.htmlArray = result;
      delTopic.htmlArray &&
       delTopic.htmlArray.forEach((htmlItem, index) => {
          if (!xth && (htmlItem.no == no)) {
              delTopic.htmlArray.splice(index, 1);
              // delIdsMap[index] = String(index);
          } else if((htmlItem.no == no) && (htmlItem && (xth == htmlItem.xth))) {
              delTopic.htmlArray.splice(index, 1);
              // delIdsMap[index] = String(index);
          }
        });
      delTopic.items &&
       delTopic.items.forEach((htmlItem, index) => {
          if ((htmlItem.no == no) && !xth) {
              // delTopic.htmlArray.splice(index, 1);
              delTopic.items.splice(index, 1);
          } else if((htmlItem.no == no) && (delTopic.items[index] && (xth == delTopic.items[index].xth))) {
              // delTopic.htmlArray.splice(index, 1);
              delTopic.items.splice(index, 1);
          }
        });
      // let result = [];
      // 删除小题的时候 析构
      // delTopic.htmlArray.length && delTopic.htmlArray.forEach((topic,index) => {
      //   // 这块写的乱 意思就是把解答题分解之后的题型再还原成subject对象
      //   if(delTopic.htmlArray[index]) {
      //   //  if ( delTopic.htmlArray[index].no == ( delTopic.htmlArray[index + 1] &&  delTopic.htmlArray[index + 1].no) ) {
      //    if ( delTopic.htmlArray[index].no == ( delTopic.htmlArray[index + 1] &&  delTopic.htmlArray[index + 1].no) && (delTopic.htmlArray[index].xth ==delTopic.htmlArray[index + 1] &&  delTopic.htmlArray[index + 1].xth)) {
      //       result.push({
      //         ...delTopic.htmlArray[index + 1],
      //         initDragHeight: delTopic.htmlArray[index].initDragHeight + delTopic.htmlArray[index + 1].initDragHeight,
      //         innerHTML: delTopic.htmlArray[index].innerHTML + delTopic.htmlArray[index + 1].innerHTML,
      //       }); 
      //    } else {
      //      // 这里得注意 解答题 删除小题的时候 判断不正确会导致删除多余相同小题题号的题型
      //      if(
      //      (delTopic.htmlArray[index-1] && delTopic.htmlArray[index].xth && (delTopic.htmlArray[index].xth == delTopic.htmlArray[index-1].xth) && (delTopic.htmlArray[index].no == delTopic.htmlArray[index-1].no))
      //      ) {
      //      } else if(delTopic.htmlArray[index-1] && !(delTopic.htmlArray[index].xth) && (delTopic.htmlArray[index].no == delTopic.htmlArray[index-1].no)) {
      //      } else {
      //        result.push(topic);
      //      }
      //    }
      //   }
      // })
      delTopic.setHtmlArray(result);
      delTopic.setStart(result && result.length && result[0].no);
      delTopic.setEnd(result && result.length &&result[result.length -1].no);
      console.log(delTopic.setStart,'setStart');
      // delTopic.setFromEdit(false);
      await this.updateSubjects({
        index: this.myindex,
        data: delTopic,
      });
      console.log("删除题型", this.subjects, delTopic);
    },
    worEdit() {
      this.setMyindex();
      const subject = this.subjects[this.myindex];
      console.log("编辑的题型1", subject);
      this.setVisibleDialog(this.visibleMap[subject.type]);
      this.setVisibleDialogIndex(this.myindex);
      // this.openDialogByType(subject, $index);
      // this.isEdit = true;
      // this.objectiveDV = true;
    },
    openDialogByType(subject, index) {
      this[this.visibleMap[subject.type]] = true;
      this.updateSubject = subject;
      this.updateSubjectIdx = index;
    },
    fillRowNum(v) {
      this.isFillChange = true;
      if (v) {
        this.fillForm.list.forEach((fill) => {
          fill.rowNum = this.fillForm.rowNum;
        });
      }
    },
    edit() {
      this.isBoxEditMut(true);
      this.allIndexMut(this.allIndex);
      switch (this.msg.types) {
        case 1:
          this.objectiveDVMut(true);
          break;
        case 2:
          this.fillDVMut(true);
          break;
        case 3:
          this.answerDVMut(true);
          break;
        case 4:
          this.writingEnDVMut(true);
          break;
        case 5:
          this.writingDVMut(true);
          break;
        case 6:
          this.chooseDVMut(true);
          break;
      }
      this.boxLoadingMut(true);
    },
    closePopover() {
      this.popoverVisible = false;
    },
    async submitPopover() {
      let subjectData = JSON.parse(JSON.stringify(this.msg)) || {};
      switch (this.msg.types) {
        case 1:
          if (
            this.msg.diffLayout === this.objectiveForm.diffLayout &&
            this.msg.rowNum === this.objectiveForm.rowNum
          ) {
            // this.closePopover();
            return;
          }
          subjectData = {
            ...subjectData,
            diffLayout: this.objectiveForm.diffLayout,
            rowNum: this.objectiveForm.rowNum,
          };
          break;
        case 2:
          if (!this.isFillChange) {
            // this.closePopover();
            return;
          }
          curForm = this.fillForm;
          break;
        case 3:
          curForm = this.form346;
          break;
        case 5:
          curForm = this.writingForm;
          break;
        case 4:
          subjectData = { ...subjectData, sty: this.form346.sty };
          break;
        case 6:
          curForm = this.form346;
          break;
      }
      subjectData = this.newModel(subjectData);
      this.setMyindex();
      this.updateSubjectsByindex(subjectData);
      // this.closePopover();
    },
    showPopover() {
      this.$parent.handleMouseEnter();
    },
    newModel(data) {
      switch (data.types) {
        case 1:
          data = new ObjectiveModel(data);
          break;
        case 4:
          data = new WriteEnModel(data);
          break;
        default:
          data = new ObjectiveModel(data);
      }
      return data;
    },
    async updateSubjectsByindex(updateSubject) {
      await this.updateSubjects({
        index: this.myindex,
        data: updateSubject,
      });
      await this.resetPageCell({
        acCardPanes: this.answerSheet.acCardPanes,
        index: this.myindex,
      });
      if(updateSubject.type != 2 ) {
        return;
      }
      updateSubject = await setObjectiveHeight(updateSubject);
      await this.updateSubjects({
        index: this.myindex,
        data: new ObjectiveModel(updateSubject),
      });
      await this.resetPageCell({
        acCardPanes: this.answerSheet.acCardPanes,
        index: this.myindex,
      });
    },
  },
};
</script>

<style lang='scss' scoped>
.component-edit-box {
  display: flex;
  position: absolute;
  top: 45px;
  right: 15px;
  z-index: 222223;
  cursor: pointer;
  .box-wrap {
    display: flex;
    width: 30px;
    height: 30px;
    border-radius: 50%;
    background: #409eff;
    justify-content: center;
    align-items: center;
    box-shadow: 2px 2px 6px #3031339e;
  }
}
.popover-cont {
  p {
    margin: 15px 0 0px;
    &:first-child {
      margin-top: 0;
    }
  }
}
.popo-text {
  padding-right: 10px;
}
</style>